document.addEventListener('DOMContentLoaded', function () {

    const siteHeader = document.getElementById('site-header');
    const burgerButton = document.getElementById('burger-button');

    if (burgerButton && siteHeader) {
        burgerButton.addEventListener('click', () => {
            siteHeader.classList.toggle('nav-open');
        });
    }

    let lastScrollY = window.pageYOffset;
    let scrollUpDistance = 0;

    window.addEventListener('scroll', () => {
        const currentScrollY = window.pageYOffset;

        // Close burger if open
        if (siteHeader.classList.contains('nav-open')) {
            siteHeader.classList.remove('nav-open');
        }

        // If below fold
        if (currentScrollY > window.innerHeight) {
            if (currentScrollY > lastScrollY) {
                // Scrolling down
                siteHeader.style.transform = 'translateY(-120px)';
                scrollUpDistance = 0; // reset up distance
            } else {
                // Scrolling up
                scrollUpDistance += lastScrollY - currentScrollY;

                if (scrollUpDistance > 100) {
                    siteHeader.style.transform = 'translateY(0)';
                    scrollUpDistance = 0; // reset after showing
                }
            }
        } else {
            // Above fold: always show
            siteHeader.style.transform = 'translateY(0)';
            scrollUpDistance = 0;
        }

        lastScrollY = currentScrollY;
    });


});